import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  uploadImage (URL, header, body, success, error) {
    Vue.axios.post(URL + 'upload/v1/upload/image', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  isLogin (URL, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/signin', body).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/add/user', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/list/user', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/remove/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRole (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/list/role', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  userDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/get/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  userUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/update/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  configDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/branch/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  confighUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/branch/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHostShift (URL, header, success, error) {
    Vue.axios.get(URL + 'company/v1/host/list', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  companyDetail (URL, header, success, error) {
    Vue.axios.get(URL + 'company/v1/list', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  companyUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  hostUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/host/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js